import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import './ImageLinks.css';
import mapa from './brasil.png';

const ImageLinks = () => {
  const [hovered, setHovered] = useState(null);

  const images = [
    {
      src: mapa,
      href: './mapa-crack',
      alt: 'Mapa do Crack',
      description: 'Mapa do crack no Brasil'
    },
    {
      src: mapa,
      href: './mapa-fronteiras',
      alt: 'Mapa das fronteiras',
      description: 'Mapa do crack nas fronteiras'
    },
    {
      src: mapa,
      href: './mapa-assistencia',
      alt: 'Mapa de Assistência',
      description: 'Mapa da Assistência Social'
    }
  ];

  const handleMouseEnter = (index) => {
    setHovered(index);
  };

  const handleMouseLeave = () => {
    setHovered(null);
  };

  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid container spacing={2} style={{ minHeight: '76vh', width: '60%', display: 'flex', alignItems: 'center' }}>
        {images.map((image, index) => (
          <Grid item key={index} xs={12} sm={6} md={4} textAlign="center">
            <a href={image.href}>
              <img
                src={image.src}
                alt={image.alt}
                className="image-link"
                style={{
                  width: '100%',
                  maxWidth: '200px',
                  height: 'auto',
                  transition: 'transform 0.2s',
                  transform: hovered === index ? 'scale(1.1)' : 'scale(1)'
                }}
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
              />
            </a>
            <Typography
              variant="body1"
              className="image-description"
              style={{ fontSize: '20px', fontWeight: '700', marginTop: '8px' }}
            >
              {image.description}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default ImageLinks;
